import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Form, Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { useDispatch } from 'react-redux';
import { MFSubmitButton, MFTextField } from '../lib/formik';
import { createAmendment } from '../redux-store/actions/application';
import { showError } from '../redux-store/actions/auth';
import { createAmendmentSchema } from '../utils/schema';
import { CommonLayout } from './commonComponents';

export interface AmendmentValueType {
  applicationNumbers: string;
  amendmentId: number;
}

const amendmentInitialValues: AmendmentValueType = {
  applicationNumbers: '',
  amendmentId: 1,
};

export default function CreateAmendment() {
  const dispatch = useDispatch();

  const onSubmit = async (values: AmendmentValueType, resetForm: () => void) => {
    try {
      const res = (await dispatch(createAmendment(values))) as unknown as any;
      throw res.response;
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    } finally {
      resetForm();
    }
  };

  return (
    <CommonLayout>
      <Formik
        initialValues={amendmentInitialValues}
        onSubmit={(values, { resetForm }) => onSubmit(values, resetForm)}
        validate={(values: AmendmentValueType) => {
          try {
            validateYupSchema(values, createAmendmentSchema, true, values);
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}>
        {({ handleSubmit }) => {
          return (
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 18,
                  fontWeight: 500,
                  mb: { xs: 2, md: 4 },
                  p: { xs: '5px 15px', md: '' },
                  bgcolor: '#e5f1f8',
                  borderRadius: '10px',
                }}>
                Create Amendment
              </Typography>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={10}
                sx={{
                  width: '100%',
                  ml: 0,
                  '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                  p: '20px 30px',
                  bgcolor: 'common.white',
                  mt: 1.5,
                }}>
                <MFTextField
                  name={`applicationNumbers`}
                  label={'Application Numbers'}
                  placeholder="Enter Application Numbers"
                  multiline
                  maxRows={20}
                />
                <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 5, mb: 5 }}>
                  <MFSubmitButton label="Submit" />
                </Box>
              </Grid>
            </Box>
          );
        }}
      </Formik>
    </CommonLayout>
  );
}
